"use client";

import { useState } from "react";
import Image from "next/image";

const gallery = [
  "/images/lifeTycho/gallery/gallery-1.webp",
  "/images/lifeTycho/gallery/gallery-2.webp",
  "/images/lifeTycho/gallery/gallery-3.webp",
  "/images/lifeTycho/gallery/gallery-4.webp",
  "/images/lifeTycho/gallery/gallery-5.webp",
  "/images/lifeTycho/gallery/gallery-17.webp",
  "/images/lifeTycho/gallery/gallery-7.webp",
  "/images/lifeTycho/gallery/gallery-8.webp",
];

const closeBtnStyle = {
  position: "absolute",
  top: "24px",
  right: "24px",
  background: "rgba(255,255,255,0.15)",
  border: "2px solid rgba(255,255,255,0.5)",
  color: "white",
  width: "44px",
  height: "44px",
  borderRadius: "50%",
  fontSize: "20px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  zIndex: 100000,
  flexShrink: 0,
};

export default function TychoLifeGallery({ tychoGallery }) {
  const apiImages = tychoGallery?.map((item) => item.url) || [];
  const displayImages = apiImages.length > 0 ? apiImages : gallery;
  const gridImages = displayImages.slice(0, 8);

  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);

  const openLightbox = (index = 0) => {
    setActiveIndex(index);
    setLightboxOpen(true);
  };

  const closeLightbox = () => setLightboxOpen(false);

  const goPrev = () => setActiveIndex((prev) => (prev - 1 + displayImages.length) % displayImages.length);

  const goNext = () => setActiveIndex((prev) => (prev + 1) % displayImages.length);

  return (
    <>
      <section className="w-full border-t border-b border-border-primary py-10! px-6! md:px-12!  2xl:px-24! flex flex-col lg:flex-row items-start justify-between gap-12 lg:gap-16 2xl:gap-24 bg-transparent box-border font-sans">
        <div className="w-full lg:w-[280px] xl:w-[320px] 2xl:w-[300px] shrink-0 flex flex-col gap-3 2xl:gap-4">
          <span className="text-xs 2xl:text-sm font-bold tracking-[0.1em] uppercase bg-gradient-to-r from-[#6366f1] to-[#d946ef] bg-clip-text text-transparent inline-block">
            MOMENTS THAT MATTER
          </span>

          <h2 className="text-text-primary text-3xl md:text-[30px] 2xl:text-[36px] font-bold leading-[1.2] m-0!">Memories that make us stronger</h2>

          <p className="text-text-secondary text-xs md:text-[13px] 2xl:text-[15px] leading-relaxed m-0! mb-6! lg:mb-4! 2xl:mb-6! max-w-[240px] lg:max-w-none!">
            From festivals to offsites, from small wins to big celebrations — we do it all together.
          </p>

          <button
            className="inline-flex items-center gap-2 whitespace-nowrap bg-transparent text-text-primary hover:text-white font-medium text-[15px] 2xl:text-[16px] py-2.5! px-5! 2xl:py-3! 2xl:px-6! rounded-lg border border-[#7c3aed] cursor-pointer tracking-wide transition-all duration-300 hover:bg-[#7c3aed] hover:shadow-[0_0_16px_rgba(124,58,237,0.4)] w-fit"
            onClick={() => openLightbox(0)}
          >
            View full gallery
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
        </div>

        <div className="flex-1 grid grid-cols-2 2xl:grid-cols-4 md:grid-cols-3 gap-3 2xl:gap-3 w-full">
          {gridImages.map((src, i) => (
            <div
              key={i}
              onClick={() => openLightbox(i)}
              className="rounded-[12px]! overflow-hidden bg-surface-secondary border border-border-primary/50 cursor-pointer w-full h-[150px] 2xl:h-[210px] relative"
            >
              <Image src={src} alt={`gallery-${i + 1}`} fill className="object-cover object-top transition-transform duration-300 hover:scale-105" />
            </div>
          ))}
        </div>
      </section>

      {lightboxOpen && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.92)",
            zIndex: 99999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {/* Close button */}
          <button
            style={closeBtnStyle}
            onClick={closeLightbox}
            onMouseEnter={(e) => (e.currentTarget.style.background = "rgba(255,255,255,0.3)")}
            onMouseLeave={(e) => (e.currentTarget.style.background = "rgba(255,255,255,0.15)")}
          >
            ✕
          </button>

          <button
            onClick={goPrev}
            style={{
              position: "absolute",
              left: "24px",
              background: "rgba(255,255,255,0.15)",
              border: "2px solid rgba(255,255,255,0.5)",
              color: "white",
              width: "44px",
              height: "44px",
              borderRadius: "50%",
              fontSize: "20px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              zIndex: 100000,
              flexShrink: 0,
              transition: "background 0.2s ease",
            }}
            onMouseEnter={(e) => (e.currentTarget.style.background = "rgba(255,255,255,0.3)")}
            onMouseLeave={(e) => (e.currentTarget.style.background = "rgba(255,255,255,0.15)")}
          >
            ‹
          </button>

          <div style={{ position: "relative", width: "80vw", height: "80vh" }}>
            <Image
              src={displayImages[activeIndex]}
              alt={`gallery-${activeIndex + 1}`}
              fill
              style={{
                borderRadius: "16px",
                objectFit: "contain",
                boxShadow: "0 0 60px rgba(0,0,0,0.8)",
              }}
            />
          </div>

          <div
            style={{
              position: "absolute",
              bottom: "24px",
              left: "50%",
              transform: "translateX(-50%)",
              color: "rgba(255,255,255,0.6)",
              fontSize: "14px",
              letterSpacing: "0.05em",
            }}
          >
            {activeIndex + 1} / {displayImages.length}
          </div>

          <button
            onClick={goNext}
            style={{
              position: "absolute",
              right: "24px",
              background: "rgba(255,255,255,0.15)",
              border: "2px solid rgba(255,255,255,0.5)",
              color: "white",
              width: "44px",
              height: "44px",
              borderRadius: "50%",
              fontSize: "20px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              zIndex: 100000,
              flexShrink: 0,
              transition: "background 0.2s ease",
            }}
            onMouseEnter={(e) => (e.currentTarget.style.background = "rgba(255,255,255,0.3)")}
            onMouseLeave={(e) => (e.currentTarget.style.background = "rgba(255,255,255,0.15)")}
          >
            ›
          </button>
        </div>
      )}
    </>
  );
}
